import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Card } from "@mui/material";
import { endpoints } from "../../services/apiurl";
import Input from "../UI/Input/Input";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";

const AddTags = () => {
  let history = useHistory();
  const [cat, setCat] = useState({
    name: "",
    color_code: "",
    type: "",
    short_name: "",
  });
  const { name, color_code, type, short_name } = cat;
  const [loading, setloading] = useState(false);

  const onInputChange = (e) => {
    const inputValue = e.target.value;
    const inputName = e.target.name;

    if (inputName === "name" || inputName === "short_name") {
      // Check for special characters
      const disallowedCharacters = /[#$%^&*0-9!@#$%^&*()+=\[\]{}:\\|<>\?]+/;
      if (disallowedCharacters.test(inputValue)) {
        alert("Special characters are not allowed in the Name field");
        return;
      }

      // Check if the input consists only of blank spaces
      if (/^\s+$/.test(inputValue)) {
        alert("Input cannot be only blank spaces");
        return;
      }
    }

    // Update the state for all other inputs
    setCat({ ...cat, [inputName]: inputValue });
  };

  const onSubmit = async (e) => {
    setloading(true);
    await axios.post(endpoints.addTag, cat).then((response) => {
      // setloading(false);
      history.goBack();
    });
  };

  return (
    <div className="ui main">
      <h2>Add Tags</h2>
      <Card className="px-3 py-3">
        <form className="ui form" onSubmit={(e) => onSubmit(e)}>
          <div className="row">
            <Input
              id="name"
              label="Name"
              type="text"
              name="name"
              place="Name"
              onChange={(e) => onInputChange(e)}
              requiredInput="required"
              value={name}
              class="col col-6"
            />

            <Input
              id="short_name"
              label="Short Name"
              type="text"
              name="short_name"
              place="Short Name"
              onChange={(e) => onInputChange(e)}
              value={short_name}
              class="col col-6"
            />
          </div>

          <div className="row">
            <Input
              id="color_code"
              label="Color Code"
              type="text"
              name="color_code"
              place="Color Code"
              onChange={(e) => onInputChange(e)}
              requiredInput=""
              value={color_code}
              class="col col-6"
            />

            <div className="col col-6">
              <label>Type</label>
              <select
                name="type"
                required
                className="form-control"
                onChange={(e) => onInputChange(e)}
              >
                <option value="">Select Type</option>
                {/* <option value="1">VEG</option>
                                <option value="2">Non-Veg</option> */}
                <option value="3">Health</option>
                <option value="4">Special</option>
                <option value="5">Allergens</option>
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col col-6">
              <div className="mt-3">
                <LoadingButton
                  type="submit"
                  loading={loading}
                  loadingPosition="start"
                  startIcon={<SaveIcon />}
                  variant="contained"
                  size="large"
                >
                  Save
                </LoadingButton>
              </div>
            </div>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default AddTags;
